<script setup lang="ts">
/**
 * ReviCoサービスロゴ。
 */
</script>

<template>
	<div class="revico-logo-wrapper">
		<a class="revico-logo" href="https://www.revico.net/" target="_blank">
			<span class="revico-logo--note">Powered by</span>
			<img class="revico-logo--img" src="@/assets/images/revico_logo.png" />
		</a>
	</div>
</template>

<style lang="scss">
.revico-logo-wrapper {
	width: 100%;
	text-align: right;
}
.revico-logo {
	height: 19px;
	color: #bbb;
	font-size: 10px;
	text-decoration: none;

	&--note {
		margin-right: 6px;
		color: #bbb;
		font-size: 10px;
	}

	&--img {
		height: 19px;
	}
}
</style>
